import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(
  Vuetify, {}
)
Vue.use(Vuetify, {
  iconfont: 'mdi'
})

// Vue.filter("formatDateToThaiString", function(date) {
//   if (date) {
//     let data = date.toString().padEnd(8, "0");
//     let [year, month, day] = [
//       data.substring(0, 4),
//       data.substring(4, 6),
//       data.substring(6)
//     ];
//     if (day.charAt(0) == "0") {
//       day = day.substring(1, 2);
//     }
//     if (month == "01") {
//       month = "มกราคม";
//     } else if (month == "02") {
//       month = "กุมภาพันธ์";
//     } else if (month == "03") {
//       month = "มีนาคม";
//     } else if (month == "04") {
//       month = "เมษายน";
//     } else if (month == "05") {
//       month = "พฤษภาคม";
//     } else if (month == "06") {
//       month = "มิถุนายน";
//     } else if (month == "07") {
//       month = "กรกฎาคม";
//     } else if (month == "08") {
//       month = "สิงหาคม";
//     } else if (month == "09") {
//       month = "กันยายน";
//     } else if (month == "10") {
//       month = "ตุลาคม";
//     } else if (month == "11") {
//       month = "พฤศจิกายน";
//     } else if (month == "12") {
//       month = "ธันวาคม";
//     }
//     return day + " " + month + " พ.ศ. " + year;
//   }
// });
